import { getData, postData, putData, deleteData, extractFile } from './index';
import { EIGHTD_ERROR, FETCH_EIGHTDS, FETCH_EIGHTD, FETCH_EIGHTDS_LIST, CREATE_EIGHTD, UPDATE_EIGHTD, DELETE_EIGHTD, UPDATE_EIGHTD_PICTURE, EXPORT_EIGHTD } from './types';

//= ===============================
// EIGHTD actions
//= ===============================

export function fetchEightDs() {
  const url = '/eightD';
  return dispatch => getData(FETCH_EIGHTDS, EIGHTD_ERROR, true, url, dispatch);
}

export function fetchEightD(eightDId) {
  const url = '/eightD/'+eightDId;
  return dispatch => getData(FETCH_EIGHTD, EIGHTD_ERROR, true, url, dispatch);
}

export function getAutocompleteList() {
  const url = '/eightD/autocompleteList'
  return dispatch => postData(FETCH_EIGHTDS_LIST, EIGHTD_ERROR, true, url, dispatch);
}

export function createEightD(program) {
  const data = {};
  data.program = program

  const url = '/eightD';
  return dispatch => postData(CREATE_EIGHTD, EIGHTD_ERROR, true, url, dispatch, data);
}

export function createEightDForConsultant(consultant) {
  var editor = consultant
  const data = {};
  data.consultantEditor = {
    firstName : editor.firstName,
    LastName : editor.lastName,
    _id : editor._id
  }
  const url = '/eightD';
  return dispatch => postData(CREATE_EIGHTD, EIGHTD_ERROR, true, url, dispatch, data);
}

export function updateEightD(eightD, eightDId) {
  const data = { eightD };
  const url = '/eightD/'+eightDId
  return dispatch => putData(UPDATE_EIGHTD, EIGHTD_ERROR, true, url, dispatch, data);
}

export function updateFieldEightD(eightD, eightDId){
  const data = { eightD };
  const url = '/eightD/updatefield/'+eightDId
  return dispatch => putData(UPDATE_EIGHTD, EIGHTD_ERROR, true, url, dispatch, data);
}

export function addFieldEightD(eightD, parent, eightDId){
  const data = { eightD };
  data.parent = parent
  const url = '/eightD/addfield/'+eightDId
  return dispatch => putData(UPDATE_EIGHTD, EIGHTD_ERROR, true, url, dispatch, data);
}

export function removeFieldEightD(i, parent, eightDId){
  const data = {
    parent : parent,
    index : i
  };
  const url = '/eightD/removefield/'+eightDId
  return dispatch => putData(UPDATE_EIGHTD, EIGHTD_ERROR, true, url, dispatch, data);
}

export function deleteEightD(eightD) {
  const url = '/eightD/'+eightD;
  return dispatch => deleteData(DELETE_EIGHTD, EIGHTD_ERROR, true, url, dispatch);
}

export function validate(eightD, eightDId){
  const data = { };
  const url = '/eightD/validate/' + eightDId
  return dispatch => putData(UPDATE_EIGHTD, EIGHTD_ERROR, true, url, dispatch, data);
}


export function extractEightD(eightDId) {
  const url = '/eightD/extract/'+eightDId;
  return dispatch => extractFile(EXPORT_EIGHTD, EIGHTD_ERROR, true, url, dispatch);
}


export function uploadPicture(file, eightDId) {
  let data = new FormData()
  data.append('file', file)
  const url = '/eightD/picture/'+eightDId;
  return dispatch => putData(UPDATE_EIGHTD_PICTURE, EIGHTD_ERROR, true, url, dispatch, data);
}
